/** Abilita lo swipe-down sull'handle (`.sheet__top`) per chiudere una bottom
 * sheet: la sheet segue il dito verso il basso; oltre soglia chiude, altrimenti
 * rientra. Pointer Events → funziona con touch e mouse. I gesti che partono da
 * un bottone (es. Chiudi) sono ignorati per non rubargli il click. */
export function enableSwipeToClose(sheet: HTMLElement, onClose: () => void): void {
  const grip = sheet.querySelector<HTMLElement>(".sheet__top");
  if (!grip) return;
  let startY = 0;
  let dy = 0;
  let dragging = false;

  const onMove = (e: PointerEvent): void => {
    if (!dragging) return;
    dy = Math.max(0, e.clientY - startY);
    sheet.style.transition = "none";
    sheet.style.translate = `0 ${dy}px`;
  };
  const onUp = (): void => {
    if (!dragging) return;
    dragging = false;
    grip.removeEventListener("pointermove", onMove);
    const threshold = Math.min(120, sheet.offsetHeight * 0.3);
    if (dy > threshold) {
      sheet.style.transition = "";
      sheet.style.translate = "";
      onClose();
    } else {
      sheet.style.transition = "translate var(--md-duration-medium) var(--md-easing-emphasized-decelerate)";
      sheet.style.translate = "0 0";
      window.setTimeout(() => {
        sheet.style.transition = "";
        sheet.style.translate = "";
      }, 250);
    }
    dy = 0;
  };
  grip.addEventListener("pointerdown", (e) => {
    if ((e.target as HTMLElement).closest("button")) return; // non rubare i tap ai bottoni
    dragging = true;
    startY = e.clientY;
    dy = 0;
    grip.setPointerCapture(e.pointerId);
    grip.addEventListener("pointermove", onMove);
    grip.addEventListener("pointerup", onUp, { once: true });
    grip.addEventListener("pointercancel", onUp, { once: true });
  });
}
